import { render, staticRenderFns } from "./AXprogramaver.vue?vue&type=template&id=3cd74020"
import script from "./AXprogramaver.vue?vue&type=script&lang=js"
export * from "./AXprogramaver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports